{
  "site": "網站導覽",
  "footerNav": "頁尾導覽",
  "home": "首頁",
  "overview": "我的總覽",
  "about": "系統介紹",
  "howto": "快速開始",
  "helpCenter": "說明中心",
  "guides": "操作手冊",
  "architecture": "技術架構",
  "trust": "Trust Center",
  "privacy": "隱私權",
  "terms": "使用條款",
  "legalNav": "法遵導覽",
  "events": "活動",
  "competitions": "探索競賽",
  "myCompetitions": "我的競賽",
  "applyToHost": "申請主辦",
  "competition": "競賽",
  "selectCompetition": "選擇競賽",
  "currentCompetition": "目前競賽：{{name}}",
  "role": "檢視身分",
  "currentRole": "目前角色：{{role}}",
  "switchWorkspace": "以其他角色開啟：{{role}}",
  "roleSwitchAnnouncement": "已切換至{{role}}工作區",
  "views": { "admin": "主辦方", "judge": "評審", "student": "參賽者", "observer": "觀察者" },
  "language": "語言",
  "languages": { "zhTW": "繁體中文", "en": "English" },
  "menu": "選單",
  "openMenu": "開啟選單",
  "primary": "主要導覽",
  "utility": "輔助功能",
  "groups": {
    "explore": "探索",
    "primary": "主要功能",
    "help": "協助",
    "preferences": "偏好"
  },
  "theme": { "switchToLight": "切換為淺色模式", "switchToDark": "切換為深色模式" },
  "manualRoleNav": "操作手冊角色",
  "manuals": {
    "student": "參賽者",
    "judge": "評審",
    "organizer": "主辦方",
    "admin": "平台管理"
  },
  "manualToc": "本頁目錄",
  "manualRelated": "其他角色操作手冊"
}
